import { Component, ExistingProvider, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AngularFireDatabase } from 'angularfire2/database';
import { ModalController } from 'ionic-angular';
import { isNil, noop } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { SupplierListModalComponent } from '../supplier-list-modal/supplier-list-modal';

export const SUPPLIER_SELECTOR_CONTROL_VALUE_ACCESSOR: ExistingProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SupplierSelectorComponent),
  multi: true
};

/**
 * This component will be responsible for showing the selected supplier through their ID
 * And will present the user with a UI they can select a supplier from
 */
@Component({
  selector: 'supplier-selector',
  templateUrl: 'supplier-selector.html',
  providers: [ SUPPLIER_SELECTOR_CONTROL_VALUE_ACCESSOR ]
})
export class SupplierSelectorComponent implements ControlValueAccessor {

  /** Stream with the name of the supplier */
  public supplierName$: Observable<string>;

  public emptyValue$: Observable<boolean>;

  /** Whether this control is disabled or not */
  public disabled;

  /** Value of this component, this will be communicated with the outside world */
  get value(): string {
    return this._value;
  }

  set value(supplierId) {
    if ( supplierId !== this._value ) {
      this.onChangeCallback(supplierId);

      // Whenever a value is written, we want to show said value internally
      //
      this.supplierName$ = this.db.object(`/suppliers/${supplierId}/name`)
        .map( wrappedValue => wrappedValue.$value );

      this.emptyValue$ = this.supplierName$.map(value => isNil(value))

      this._value = supplierId;
    }
  }

  private _value: string;

  constructor( private db: AngularFireDatabase, private modalCtrl: ModalController ) { }


  public openSupplierSelector() {
    const supplierListModal = this.modalCtrl.create(SupplierListModalComponent);

    supplierListModal.present().catch( error => {
      console.error('[supplier-selector] error opening supplier list', error);
    });

    supplierListModal.onDidDismiss( id => {
      if ( id ) {
        this.value = id;
      }
    });

  }

  writeValue( id: string ): void {
    this.value = id;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /** Value we will call whenever our form is touched */
  private onTouchedCallback: Function = noop;

  /** Function we will call whenever the value changes */
  private onChangeCallback: (val: any) => void = noop;
}



// WEBPACK FOOTER //
// ./src/modules/supplier-selector/supplier-selector/supplier-selector.ts